// extracted by mini-css-extract-plugin
export default {"container":"storypage_container__EfQ33"};